<template>
    <div>
        <div class="ban">
            <div class="ban_text">
                <p class="p1">PLATFORM INTRODUCTION</p>
                <p class="p2">关于智信供应链的介绍</p>
            </div>
        </div>
        <div class="platform_intro center">
            <div class="develop_list">
                <div class="l">
                    <div class="line_top">
                        <p>背景</p>
                        <p>Background</p>
                    </div>
                    <div style="height: 10px;"></div>
                    <div class="desc_box">
                        北京中采智信信息技术有限公司注册于北京房山，注册
                        资本金500万元，是一家致力于建材领域的数字化供应
                        链管理服务提供商，系河北建工物流有限公司全资子公
                        司、河北建工集团三级子公司。公司拥有一支包括资深
                        网站设计以及程序开发人员在内的技术研发团队，以自
                        主研发实力为企业打造更完善的互联网解决方案。
                    </div>
                </div>
                <div class="m">
                    <div class="column_line">
                        <div class="circle"></div>
                    </div>
                </div>
                <div class="r">
                    <img src="../assets/platform_company.png" alt="">
                </div>
            </div>
            <div class="develop_list">
                <div class="r">
                    <img src="../assets/platform_target.png" alt="">
                </div>
                <div class="m">
                    <div class="column_line">
                        <div class="circle"></div>
                    </div>
                </div>
                <div class="l">
                    <div class="line_top">
                        <p>目标</p>
                        <p>Target</p>
                    </div>
                    <div style="height: 10px;"></div>
                    <div class="desc_box">
                        中采智信公司负责全面推进河北建工集团的数字化平台建设，
                        运用最新的互联网技术，全面打造集招标采购、电子签约、
                        物流运输、线上支付、供应链数据增信等功能于一体的一站
                        式服务平台。
                        平台基于区块链技术的去中心化、交易溯源、不可篡改等特
                        性，完整真实地记录国央企—核心企业—供应商三方交易过
                        程，包括招标中标信息、电子合同、物流轨迹、发票及付款
                        信息等关键业务数据进行上链存储，以此打通平台与资方信
                        息渠道，以交易数据打造上游供应商增信凭证，协助供应商
                        在线融资，由此构建建材领域B2B供应链管理服务平台的生
                        态化闭环，促进供应链业务高效运转。
                    </div>
                </div>
            </div>
            <div class="develop_list">
                <div class="l">
                    <div class="line_top">
                        <p>特点</p>
                        <p>Characteristic</p>
                    </div>
                    <div style="height: 10px;"></div>
                    <div class="desc_box">
                        平台基于区块链技术，收集和梳理整个供应链中的信息，对
                        建材贸易全链路数据进行上链存证，营造“链上可信”的平
                        台环境。并且链接外部金融机构，向供应链上下游提供线上
                        化、多元化的供应链数字增信服务。
                    </div>
                </div>
                <div class="m">
                    <div class="column_line">
                        <div class="circle"></div>
                    </div>
                </div>
                <div class="r">
                    <img src="../assets/platform_tedian.png" alt="">
                </div>
            </div>
            <div class="develop_list">
                <div class="r">
                    <img src="../assets/platform_develop.png" alt="">
                </div>
                <div class="m">
                    <div class="column_line last_column_line">
                        <div class="circle"></div>
                    </div>
                </div>
                <div class="l">
                    <div class="line_top">
                        <p>发展</p>
                        <p>Develop</p>
                    </div>
                    <div style="height: 10px;"></div>
                    <div class="desc_box">
                        平台将利用区块链技术，不断的融合更多的链上相关企业，
                        让更多的业务实现信息化和数字化，进一步的提高链上数据
                        的可信度，为供应商带来更多的服务。
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import {
    getNewsDetailById
} from "@/api/api";
export default {
    data() {
        return {
            con: {},
            id: ''
        };
    },
    mounted() {
        this.id = this.$route.query.id
        // this.getBodyContent()
    },
    methods: {
        getBodyContent() {
            getNewsDetailById(this.id).then(res => {
                console.log(res)
                if (res.code == 1000) {
                    this.con = res.data
                } else {

                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.ban {
    background: url(../assets/banner_new.png) no-repeat center center;
    background-size: cover;
    height: 430px;
    overflow: hidden;
    // margin-top: 110px;

    .ban_text {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .p1 {
            font-size: 50px;
            font-weight: bold;
            color: #FFFFFF;
        }

        .p2 {
            font-size: 30px;
            color: #FFFFFF;
        }
    }
}

@media screen and (max-width: 750px) {
    .ban {
        height: 346px;
        margin-top: 206px;
    }
}

.platform_intro {
    margin: 100px auto 130px;

    .develop_list {
        display: flex;

        .l {
            width: 45%;

            // margin:10px auto;
            .line_top {
                padding: 20px 30px;
                border-radius: 2px 0px 0px 2px;
                opacity: 1;
                background: #233B83;
                display: flex;
                align-items: center;

                p {
                    font-size: 32px;
                    font-weight: 500;
                    color: #FFFFFF;
                }

                p:last-child {
                    font-size: 24px;
                    font-weight: 500;
                    color: #FFFFFF;
                    margin-left: 20px;
                }
            }

            .desc_box {
                border-radius: 2px;
                box-sizing: border-box;
                border: 1px solid #D8D8D8;
                padding: 20px;
                font-size: 20px;
                color: #808080;
                // line-height: 30px;
                text-align: left;
                // margin-top: 20px;
                margin-bottom: 20px;

            }
        }

        .m {
            width: 10%;

            .column_line {
                margin: 0 auto;
                width: 5px;
                height: 100%;
                opacity: 1;
                background: #39639E;
                position: relative;

                .circle {
                    position: absolute;
                    top: calc(50% - 10px);
                    left: -8px;
                    width: 21px;
                    height: 21px;
                    opacity: 1;
                    background: #39639E;
                }
            }

            .last_column_line {
                height: calc(100% - 20px);
            }
        }

        .r {
            width: 45%;
            // margin: 10px auto;

            img {
                width: 100%;
                height: auto;
                padding-bottom: 20px;

            }
        }

    }
}

@media screen and (max-width: 750px) {
    .center {
        width: 80%;
    }

}</style>